import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { CfetBaseComponent, CfetService, CFETILMEndpointsConstant, CfetPageNamesConstant } from '../../../cfet-core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-utf-auth-separate-id-form',
    templateUrl: './utf-auth-separate-id-form.component.html',
    styleUrls: ['./utf-auth-separate-id-form.component.scss'],
    standalone: false
})
export class UtfAuthSeparateIdFormComponent extends CfetBaseComponent implements OnInit {
  emailAddressForm: UntypedFormGroup;
  emailAddress: UntypedFormControl;
  emailAddressError: boolean;
  useridValues: any;
  disabledContinueButton = true;
  userID = '';
  userid: any;
  attEmail: any;
  contactEmail: any;
  separateidValues: any = {};
  fName: '';
  lName: '';
  firstName: '';
  lastName: '';
  httpHeaders: any = {};
  showDupeErrorMsg = false;
  @Output() showHomepage = new EventEmitter<any>();
  separateID: any;
  showCancelModal = false;
  openCancelModal = '';

  constructor(private cfetService: CfetService, private router: Router) {
    super();
  }

  ngOnInit () {
    this.emailAddress = new UntypedFormControl('', [Validators.required]);
    this.emailAddressForm = new UntypedFormGroup({ emailAddress: this.emailAddress });

    if (sessionStorage.getItem('AMUTFHeaders') && Object.keys(sessionStorage.getItem('AMUTFHeaders')).length !== 0) {
      this.httpHeaders = JSON.parse(sessionStorage.getItem('AMUTFHeaders'));
      this.firstName = this.httpHeaders.firstname;
      this.lastName = this.httpHeaders.lastname;
      this.attEmail = this.httpHeaders.userid;
      this.contactEmail = this.httpHeaders.email;
    }
    if (sessionStorage.getItem('separateIDValues') && Object.keys(sessionStorage.getItem('separateIDValues')).length !== 0) {
      this.separateidValues = JSON.parse(sessionStorage.getItem('separateIDValues'));
      this.fName = this.separateidValues.firstName;
      this.lName = this.separateidValues.lastName;
    }
    if (sessionStorage.getItem('separateId') && Object.keys(sessionStorage.getItem('separateId')).length !== 0) {
      this.useridValues = JSON.parse(sessionStorage.getItem('separateId'));
      this.userid = this.useridValues.userID;
      this.attEmail = this.useridValues.attEmail;
    }
  }

  setRequest() {
    return {
      'userid': this.emailAddress.value.trim(),
      'company_id': environment.companyId,
      'notification_value': '',
      'notification_method': 'list',
      'notification_flow': 'actv'
    };
  }

  continue (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.KeyCode === 13) {
      const request = this.setRequest();
      this.cfetService.cfetLivePost(request, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((_data) => {
        /* do nothing */
      }, (error) => {
        if (error && error.error && error.error.errorcode && error.error.errorcode === 1033) {
          sessionStorage.removeItem('ngStorage-singleIDInfo');
          this.separateID = true;
          const separateIDValues = {
            'separateID': this.separateID,
            'userID': this.emailAddress.value,
            'attEmail': this.attEmail,
            'firstName': this.firstName ? this.firstName : this.fName,
            'lastName': this.lastName ? this.lastName : this.lName
          };
          sessionStorage.removeItem('singleIdForm');
          sessionStorage.setItem('separateIDValues', JSON.stringify(separateIDValues));
          this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION_UTF]);
        } else {
          this.showDupeErrorMsg = true;
          this.emailAddressError = false;
          this.disabledContinueButton = true;
        }
      });
    }
  }

  onChangeEmail () {
    this.showDupeErrorMsg = false;
  }

  validateEmailAddress () {
    const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
    if (this.emailAddress.value === '' || this.emailAddress.value === undefined || this.emailAddress.value === null) {
      this.disabledContinueButton = true;
    } else {
      this.setValueToDisabledContinueButton(emailRegex);
    }
  }

  setValueToDisabledContinueButton(emailRegex) {
    this.emailAddressError = !emailRegex.test(this.emailAddress.value);
    if (this.emailAddressError) {
      this.disabledContinueButton = true;
      this.showDupeErrorMsg = false;
    } else {
      this.disabledContinueButton = false;
    }
  }

  use1ID (event) {
    if (event.type === 'click' || event.key === 'Enter' || event.Code === 13) {
      this.showHomepage.emit(true);
    }
  }

  cancelApplication (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal (event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }
}
